export default "__VITE_ASSET__B_oJ4Zi___"